import { render, staticRenderFns } from "./GestionHidrocarburosCrearViaje.vue?vue&type=template&id=2bb36a88"
import script from "./GestionHidrocarburosCrearViaje.vue?vue&type=script&lang=js"
export * from "./GestionHidrocarburosCrearViaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports